function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M571.865 296.538C566.687 300.653 562.035 305.389 558.013 310.639C533.231 343.403 544.488 388.852 515.289 419.191C487.047 448.573 433.145 451.679 395.205 472.923C378.718 482.175 365.797 494.573 355.011 508.307H0C1.58575 506.84 3.13218 505.333 4.61308 503.799C25.5816 482.228 37.9007 456.279 52.3559 431.536C66.8111 406.793 84.5164 382.064 112.47 366.377C150.397 345.08 204.299 341.974 232.554 312.645C261.74 282.306 250.483 236.843 275.291 204.093C304.346 165.707 370.292 158.617 413.186 129.681C447.128 106.773 540.411 29.7254 571.865 0V296.538Z",
  fill: "#DCE5F2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M351.591 147.137C368.514 142.185 384.624 134.79 399.412 125.186C402.336 123.524 404.874 121.259 406.856 118.541C408.651 115.71 409.162 111.805 407.236 109.066C404.903 105.75 399.923 105.37 396.214 106.982C392.506 108.594 389.662 111.687 386.752 114.479C375.329 125.349 360.941 132.591 345.405 135.29C341.133 136.024 335.641 137.557 335.405 141.842C335.248 144.844 338.171 147.281 341.146 147.701C344.405 148.217 347.738 147.988 350.896 147.032",
  fill: "#DCE5F2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M414.889 494.114C412.111 499.357 406.397 502.331 401.207 505.319C399.53 506.289 397.865 507.298 396.24 508.36H372.86C381.955 500.418 391.055 492.489 400.159 484.574C402.78 482.293 405.768 479.882 409.215 480.105C415.191 480.472 417.668 488.872 414.889 494.114Z",
  fill: "#DCE5F2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.6238 433.24C40.8064 416.759 50.6672 401.905 63.4556 389.809C66.6795 386.769 70.4145 383.007 69.5103 378.669C68.606 374.332 63.5604 372.366 59.4191 373.27C55.2778 374.174 51.9491 377.202 49.0528 380.321C36.9786 393.267 28.3019 409.004 23.7988 426.124C22.9145 428.821 22.6326 431.68 22.9731 434.498C23.1608 435.902 23.7377 437.226 24.6387 438.319C25.5397 439.412 26.7287 440.232 28.0711 440.684C30.8232 441.379 34.152 439.282 34.0472 436.464",
  fill: "#DCE5F2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M471.53 344.294C463.853 342.945 455.953 344.647 449.513 349.038C451.69 352.239 454.479 354.976 457.72 357.093C460.961 359.209 464.589 360.662 468.395 361.367C472.201 362.073 476.108 362.017 479.893 361.204C483.677 360.39 487.262 358.834 490.441 356.626C485.992 350.202 479.203 345.775 471.53 344.294Z",
  fill: "#22751B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M393.659 252.085C385.896 252.841 378.737 256.604 373.712 262.569C376.674 265.062 380.101 266.943 383.794 268.104C387.487 269.265 391.374 269.683 395.229 269.333C399.085 268.984 402.833 267.873 406.257 266.067C409.681 264.26 412.713 261.793 415.178 258.808C409.16 253.839 401.435 251.426 393.659 252.085Z",
  fill: "#22751B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M528.29 304.873C520.6 303.51 512.683 305.213 506.233 309.617C508.413 312.816 511.205 315.551 514.448 317.666C517.69 319.78 521.319 321.231 525.126 321.935C528.932 322.639 532.84 322.583 536.624 321.769C540.409 320.955 543.994 319.399 547.175 317.192C542.732 310.775 535.953 306.353 528.29 304.873Z",
  fill: "#22751B"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M404.811 294.127C397.129 292.761 389.218 294.454 382.768 298.845C384.945 302.045 387.734 304.783 390.975 306.899C394.216 309.016 397.844 310.468 401.65 311.174C405.455 311.88 409.363 311.824 413.147 311.01C416.932 310.196 420.517 308.64 423.696 306.433C419.252 300.02 412.473 295.602 404.811 294.127Z",
  fill: "#22751B"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M406.174 228.076C402.788 235.111 402.29 243.192 404.785 250.591C408.454 249.358 411.842 247.411 414.754 244.861C417.666 242.311 420.044 239.21 421.75 235.735C423.456 232.261 424.457 228.483 424.694 224.62C424.931 220.756 424.4 216.884 423.132 213.227C415.757 215.772 409.67 221.101 406.174 228.076Z",
  fill: "#22751B"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M463.615 213.358C461.397 205.874 456.335 199.555 449.514 195.758C447.626 199.139 446.428 202.862 445.987 206.709C445.547 210.557 445.874 214.454 446.949 218.174C448.023 221.895 449.825 225.365 452.249 228.385C454.674 231.405 457.673 233.915 461.073 235.769C464.814 228.917 465.726 220.874 463.615 213.358Z",
  fill: "#22751B"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M457.822 320.01C455.592 312.53 450.527 306.218 443.708 302.422C441.82 305.802 440.621 309.523 440.18 313.369C439.738 317.215 440.064 321.11 441.138 324.829C442.211 328.549 444.012 332.018 446.435 335.038C448.857 338.057 451.855 340.566 455.253 342.42C459.003 335.572 459.925 327.529 457.822 320.01Z",
  fill: "#22751B"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M488.594 215.783C480.508 216.137 473.287 220.239 467.849 226.739C473.825 232.741 481.386 236.201 489.472 235.913C497.558 235.624 504.793 231.457 510.231 224.957C504.242 218.902 496.694 215.429 488.594 215.783Z",
  fill: "#22751B"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M488.423 276.395C483.73 279.685 480.508 284.68 479.446 290.313C482.238 290.843 485.107 290.815 487.888 290.23C490.669 289.645 493.306 288.515 495.648 286.906C497.99 285.296 499.99 283.239 501.532 280.852C503.075 278.466 504.129 275.797 504.635 273.001C498.995 271.971 493.176 273.189 488.423 276.395Z",
  fill: "#22751B"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M405.624 331.477C400.933 334.764 397.712 339.754 396.647 345.382C399.439 345.915 402.309 345.89 405.091 345.306C407.874 344.723 410.512 343.594 412.855 341.983C415.198 340.373 417.198 338.315 418.739 335.926C420.281 333.538 421.333 330.867 421.835 328.07C416.194 327.05 410.378 328.273 405.624 331.477Z",
  fill: "#22751B"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M482.853 257.982C480.407 260.948 479.217 264.753 479.538 268.584C481.434 268.42 483.278 267.882 484.965 267.001C486.652 266.12 488.148 264.913 489.366 263.451C490.585 261.989 491.502 260.3 492.064 258.482C492.626 256.664 492.823 254.753 492.643 252.858C488.837 253.226 485.325 255.064 482.853 257.982Z",
  fill: "#22751B"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M420.42 357.937C417.983 360.907 416.799 364.71 417.117 368.539C419.019 368.383 420.871 367.85 422.565 366.973C424.26 366.095 425.763 364.89 426.989 363.427C428.214 361.965 429.136 360.273 429.703 358.451C430.269 356.629 430.468 354.712 430.288 352.812C426.455 353.164 422.913 355.004 420.42 357.937Z",
  fill: "#22751B"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M428.047 262.15C425.608 265.114 424.423 268.914 424.744 272.739C426.64 272.574 428.485 272.036 430.172 271.155C431.859 270.274 433.354 269.068 434.573 267.606C435.791 266.144 436.708 264.455 437.27 262.637C437.833 260.819 438.029 258.907 437.849 257.012C434.037 257.383 430.52 259.226 428.047 262.15Z",
  fill: "#22751B"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M391.169 205.259C388.721 208.224 387.535 212.031 387.866 215.862C389.762 215.697 391.607 215.159 393.294 214.278C394.981 213.397 396.477 212.19 397.695 210.728C398.913 209.266 399.83 207.578 400.392 205.759C400.955 203.941 401.152 202.03 400.972 200.135C397.163 200.506 393.648 202.344 391.169 205.259Z",
  fill: "#22751B"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M524.633 284.429C522.197 287.395 521.012 291.193 521.331 295.018C523.227 294.853 525.071 294.315 526.758 293.434C528.445 292.553 529.941 291.347 531.159 289.885C532.378 288.423 533.295 286.734 533.857 284.916C534.419 283.098 534.616 281.186 534.436 279.292C530.624 279.662 527.107 281.505 524.633 284.429Z",
  fill: "#22751B"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M473.588 273.722C470.439 271.521 466.555 270.637 462.763 271.258C463.073 273.135 463.751 274.933 464.758 276.547C465.766 278.162 467.083 279.56 468.634 280.663C470.185 281.766 471.939 282.55 473.795 282.972C475.651 283.393 477.571 283.443 479.446 283.118C478.794 279.342 476.692 275.97 473.588 273.722Z",
  fill: "#22751B"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M420.066 278.177C416.921 275.965 413.033 275.08 409.241 275.714C409.547 277.594 410.223 279.394 411.229 281.011C412.236 282.629 413.553 284.03 415.104 285.136C416.655 286.241 418.41 287.028 420.267 287.451C422.124 287.874 424.047 287.925 425.924 287.6C425.283 283.812 423.179 280.428 420.066 278.177Z",
  fill: "#22751B"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M373.66 198.405C370.511 196.204 366.627 195.32 362.835 195.941C363.141 197.823 363.818 199.625 364.825 201.243C365.832 202.861 367.15 204.263 368.703 205.369C370.255 206.474 372.012 207.261 373.871 207.683C375.729 208.105 377.653 208.154 379.531 207.828C378.877 204.042 376.77 200.661 373.66 198.405Z",
  fill: "#22751B"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M441.257 237.171C436.015 234.852 430.071 234.683 424.705 236.699C425.699 239.36 427.21 241.797 429.151 243.871C431.091 245.944 433.424 247.613 436.013 248.78C438.602 249.948 441.397 250.591 444.236 250.672C447.075 250.753 449.902 250.271 452.554 249.254C450.512 243.905 446.457 239.568 441.257 237.171Z",
  fill: "#22751B"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M464.453 247.97C458.743 248.285 453.381 250.82 449.513 255.033C451.602 256.96 454.051 258.454 456.721 259.427C459.39 260.401 462.226 260.836 465.064 260.707C467.903 260.578 470.687 259.887 473.257 258.675C475.827 257.463 478.131 255.753 480.036 253.644C475.784 249.787 470.19 247.75 464.453 247.97Z",
  fill: "#22751B"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M499.89 328.03C494.395 326.417 488.486 327.019 483.43 329.708C484.758 332.218 486.571 334.441 488.763 336.247C490.955 338.054 493.484 339.408 496.202 340.231C498.921 341.055 501.775 341.332 504.601 341.046C507.428 340.761 510.169 339.918 512.668 338.567C509.951 333.518 505.364 329.736 499.89 328.03Z",
  fill: "#22751B"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M469.853 294.716C464.389 292.979 458.462 293.449 453.34 296.027C454.604 298.573 456.36 300.843 458.506 302.706C460.652 304.569 463.146 305.988 465.844 306.881C468.543 307.775 471.391 308.124 474.225 307.91C477.059 307.696 479.822 306.922 482.356 305.633C479.775 300.5 475.287 296.581 469.853 294.716Z",
  fill: "#22751B"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M391.864 230.647C392.97 227.308 387.372 222.449 379.361 219.795C371.35 217.141 363.959 217.696 362.853 221.035C361.746 224.375 367.344 229.233 375.355 231.887C383.366 234.541 390.757 233.986 391.864 230.647Z",
  fill: "#22751B"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M494.072 195.941C489.375 199.225 486.148 204.215 485.082 209.846C487.873 210.376 490.742 210.348 493.523 209.763C496.304 209.178 498.941 208.048 501.283 206.439C503.625 204.829 505.625 202.772 507.167 200.385C508.71 197.999 509.764 195.33 510.27 192.534C504.633 191.507 498.817 192.73 494.072 195.941Z",
  fill: "#22751B"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M446.892 392.941L427.824 346.483C425.019 339.681 422.136 332.63 421.271 325.121C420.406 317.612 421.874 309.683 423.25 302.2C423.617 300.208 423.984 298.268 424.312 296.224C425.688 287.849 426.644 277.103 421.822 268.257C418.729 262.556 413.513 258.244 408.467 254.077C403.16 249.686 397.669 245.152 394.523 238.953C392.97 235.6 391.797 232.083 391.024 228.469C390.349 225.507 389.447 222.603 388.324 219.78C385.774 213.847 381.325 208.929 375.678 205.797L376.241 204.788C382.142 208.05 386.786 213.188 389.438 219.387C390.583 222.265 391.503 225.227 392.19 228.246C392.952 231.773 394.099 235.205 395.611 238.481C398.651 244.471 404.038 248.966 409.254 253.238C414.47 257.51 419.738 261.848 422.896 267.746C427.889 276.919 426.92 287.915 425.517 296.473C425.19 298.465 424.823 300.404 424.456 302.462C423.145 309.866 421.678 317.533 422.49 325.055C423.303 332.578 426.133 339.366 428.899 346.024L447.98 392.495L446.892 392.941Z",
  fill: "#22751B"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M427.496 288.832C427.128 288.847 426.761 288.787 426.416 288.657C426.072 288.526 425.757 288.327 425.491 288.072L426.356 287.299C426.581 287.479 426.846 287.603 427.129 287.66C427.412 287.717 427.704 287.705 427.981 287.627C430.602 287.155 436.631 282.778 446.905 258.795C462.108 223.319 488.476 207.278 488.738 207.12L489.327 208.116C489.078 208.274 463.025 224.144 447.967 259.227C437.941 282.607 431.624 288.19 428.086 288.754L427.496 288.832Z",
  fill: "#22751B"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M439.2 371.435L438.073 371.147C438.151 370.832 446.447 339.314 468.215 335.762C489.341 332.316 525.957 288.334 526.324 287.889L527.215 288.623C525.708 290.457 489.944 333.39 468.399 336.916C447.378 340.336 439.278 371.121 439.2 371.435Z",
  fill: "#22751B"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M486.457 327.873L485.33 327.611C485.33 327.611 486.785 320.835 481.818 306.315C476.733 291.453 479.8 265.125 479.826 264.862L480.979 264.994C480.979 265.256 477.913 291.335 482.919 305.935C488.004 320.835 486.523 327.598 486.457 327.873Z",
  fill: "#548A13"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M456.459 456.659H432.961C430.342 456.66 427.804 455.742 425.791 454.066C423.777 452.39 422.415 450.062 421.94 447.486L411.521 392.443H477.913L467.494 447.486C467.016 450.063 465.651 452.392 463.635 454.068C461.62 455.743 459.081 456.66 456.459 456.659Z",
  fill: "#FF706F"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M484.256 392.456H406.397V400.359H484.256V392.456Z",
  fill: "#EE3537"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M335.916 469.398C335.575 474.247 288.96 474.902 231.807 470.852C174.655 466.803 128.603 459.595 128.943 454.798C129.284 450.002 175.9 449.294 233.052 453.344C290.205 457.393 336.27 464.536 335.916 469.398Z",
  fill: "#F0F0F0"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M303.703 269.646L288.016 406.191L186.437 397.829L206.54 261.652L303.703 269.646Z",
  fill: "#FF706F"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M303.704 269.646L303.599 399.022L288.017 406.191L303.704 269.646Z",
  fill: "#EE3537"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M272.591 281.808C270.455 289.933 265.724 296.433 259.617 299.592C256.506 301.203 253.004 301.902 249.513 301.61C247.332 301.489 245.199 300.915 243.252 299.925C241.305 298.934 239.585 297.549 238.203 295.857C235.005 291.715 233.983 285.857 235.097 277.942C235.267 276.736 235.464 275.53 235.674 274.311C236.345 270.954 236.678 267.539 236.67 264.115L239.998 264.391C239.981 267.911 239.63 271.421 238.95 274.875C238.767 276.054 238.57 277.247 238.387 278.413C237.404 285.399 238.203 290.444 240.837 293.838C244.415 298.465 252.16 299.736 258.084 296.669C263.326 293.917 267.48 288.203 269.381 280.943C270.464 276.349 270.979 271.639 270.914 266.92L274.23 267.182C274.293 272.106 273.742 277.019 272.591 281.808Z",
  fill: "#2A2A7B"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M234.075 316.576L224.39 400.791L161.746 395.641L174.144 311.635L234.075 316.576Z",
  fill: "#8678FA"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M234.075 316.576L235.53 401.014L224.39 400.791L234.075 316.576Z",
  fill: "#2B2981"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M214.837 324.072C214.336 326.355 213.367 328.508 211.991 330.396C210.615 332.284 208.862 333.866 206.843 335.042C204.921 336.033 202.759 336.465 200.604 336.287C199.26 336.207 197.947 335.851 196.747 335.24C195.547 334.629 194.487 333.776 193.632 332.735C191.653 330.114 191.011 326.562 191.719 321.687C191.824 320.94 191.942 320.193 192.06 319.446C192.485 317.381 192.691 315.277 192.676 313.169L194.733 313.326C194.731 315.496 194.516 317.66 194.091 319.787L193.737 321.976C193.134 326.287 193.632 329.393 195.244 331.477C197.459 334.334 202.243 335.12 205.886 333.233C207.654 332.188 209.186 330.787 210.386 329.121C211.586 327.454 212.427 325.556 212.858 323.548C213.534 320.716 213.851 317.81 213.801 314.899L215.846 315.069C215.894 318.101 215.555 321.127 214.837 324.072Z",
  fill: "#DCE5F2"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M386.175 284.18L340.949 280.641L299.051 407.108L162.021 396.362L138.654 297.901L330.635 311.596",
  stroke: "#1D2582",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M299.038 407.108L300.611 407.226C308.395 407.842 314.542 410.568 312.982 430.501C312.688 434.242 310.92 437.714 308.066 440.152C305.213 442.59 301.508 443.795 297.767 443.502L161.864 432.847",
  stroke: "#1D2582",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M272.342 453.907C272.14 456.476 272.704 459.047 273.963 461.296C275.223 463.544 277.121 465.368 279.417 466.538C281.713 467.707 284.305 468.169 286.864 467.865C289.423 467.562 291.834 466.506 293.793 464.831C295.752 463.157 297.17 460.939 297.868 458.458C298.566 455.978 298.513 453.346 297.715 450.895C296.917 448.445 295.41 446.287 293.385 444.693C291.36 443.099 288.908 442.142 286.338 441.942C282.896 441.674 279.488 442.784 276.864 445.028C274.239 447.271 272.613 450.465 272.342 453.907Z",
  fill: "#1D2582"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M167.107 445.625C166.905 448.193 167.469 450.764 168.728 453.012C169.987 455.259 171.884 457.083 174.179 458.253C176.475 459.423 179.066 459.885 181.624 459.582C184.183 459.28 186.594 458.225 188.553 456.552C190.512 454.878 191.931 452.662 192.631 450.182C193.33 447.703 193.278 445.071 192.482 442.621C191.686 440.171 190.182 438.011 188.158 436.416C186.135 434.821 183.685 433.862 181.116 433.659C177.672 433.392 174.263 434.501 171.637 436.744C169.01 438.988 167.381 442.181 167.107 445.625Z",
  fill: "#1D2582"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M290.493 309.342L278.96 404.631",
  stroke: "#1D2582",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M262.5 307.153L252.999 402.6",
  stroke: "#1D2582",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M234.52 304.965L227.024 400.555",
  stroke: "#1D2582",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M206.527 302.763L201.049 398.524",
  stroke: "#1D2582",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M176.529 300.417L175.074 396.493",
  stroke: "#1D2582",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M320.295 340.061L145.431 326.366",
  stroke: "#1D2582",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M307.845 375.354L155.587 363.428",
  stroke: "#1D2582",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M427.889 379.036L423.984 465.951L359.479 465.138L366.176 378.263L427.889 379.036Z",
  fill: "#8678FA"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M427.89 379.036L435.399 465.374L423.984 465.951L427.89 379.036Z",
  fill: "#2B2981"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M408.729 388.092C408.377 390.463 407.537 392.735 406.262 394.765C404.988 396.795 403.307 398.539 401.325 399.887C399.431 401.039 397.251 401.634 395.034 401.604C393.653 401.622 392.282 401.353 391.01 400.814C389.737 400.275 388.591 399.477 387.643 398.472C385.428 395.995 384.524 392.338 384.891 387.293C384.891 386.519 385.009 385.759 385.087 384.973C385.365 382.827 385.422 380.657 385.258 378.499H387.381C387.532 380.719 387.466 382.949 387.184 385.157C387.119 385.904 387.04 386.664 386.988 387.411C386.673 391.866 387.394 395.012 389.203 397.043C391.679 399.808 396.62 400.267 400.224 398.078C401.955 396.879 403.42 395.336 404.529 393.546C405.639 391.756 406.368 389.757 406.672 387.673C407.153 384.723 407.267 381.726 407.013 378.748H409.123C409.388 381.867 409.256 385.007 408.729 388.092Z",
  fill: "#DCE5F2"
});

function SvgGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 509,
    viewBox: "0 0 572 509",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref36), _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.f2d8b66c.svg";
export { ForwardRef as ReactComponent };